export const PersianFormal = [
  {
    sentence:
      "با افتخار دوره {COURSE_TITLE} را در فرادرس به پایان رساندم و گواهینامه‌ام را دریافت کردم.",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "توانستم دوره {COURSE_TITLE} را در فرادرس با موفقیت به پایان برسانم و گواهینامه‌ام را کسب کنم.",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "خوشحالم که دوره {COURSE_TITLE} را در فرادرس به اتمام رساندم و گواهینامه خود را دریافت کردم.",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "افتخار می‌کنم که دوره {COURSE_TITLE} را در فرادرس گذرانده و گواهینامه دریافت کرده‌ام.",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "با موفقیت دوره {COURSE_TITLE} را در فرادرس پشت سر گذاشته و گواهینامه کسب نمودم.",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "به تازگی دوره {COURSE_TITLE} را در فرادرس تمام کرده و گواهینامه‌ام را دریافت نمودم.",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "با گذراندن دوره {COURSE_TITLE} در فرادرس، اکنون گواهینامه خود را دریافت کرده‌ام.",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "دوره {COURSE_TITLE} را در فرادرس به پایان رسانده و گواهینامه‌ام را دریافت نمودم.",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "توانستم با موفقیت دوره {COURSE_TITLE} را در فرادرس بگذرانم و گواهینامه بگیرم.",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "خوشحالم که دوره {COURSE_TITLE} را با موفقیت به پایان رسانده و گواهینامه دریافت کرده‌ام.",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "با افتخار اعلام می‌کنم که دوره {COURSE_TITLE} را در فرادرس گذرانده‌ام و گواهینامه گرفته‌ام.",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "اینک با افتخار دوره {COURSE_TITLE} را در فرادرس به اتمام رسانده و گواهینامه خود را اخذ نموده‌ام.",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "دوره {COURSE_TITLE} را با موفقیت گذرانده و گواهینامه خود را از فرادرس دریافت کردم.",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "به تازگی موفق به اتمام دوره {COURSE_TITLE} در فرادرس شدم و گواهینامه‌ام را دریافت نمودم.",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "با اتمام دوره {COURSE_TITLE} در فرادرس، اکنون گواهینامه‌ام را در دست دارم.",
    tone: "formal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "با افتخار دوره‌ای در فرادرس را به پایان رساندم و گواهینامه‌ام را دریافت کردم.",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "توانستم دوره‌ای در فرادرس با موفقیت به پایان برسانم و گواهینامه‌ام را کسب کنم.",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "خوشحالم که یکی از دوره‌های فرادرس را به اتمام رساندم و گواهینامه خود را دریافت کردم.",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "افتخار می‌کنم که دوره‌ای از فرادرس را گذرانده و گواهینامه دریافت کرده‌ام.",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "با موفقیت یکی از دوره‌های فرادرس را پشت سر گذاشته و گواهینامه کسب نمودم.",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "به تازگی یکی از دوره‌های فرادرس را تمام کرده و گواهینامه‌ام را دریافت نمودم.",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "با گذراندن دوره‌ای در فرادرس، اکنون گواهینامه خود را دریافت کرده‌ام.",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "یکی از دوره‌های فرادرس را به پایان رسانده و گواهینامه‌ام را دریافت نمودم.",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "توانستم با موفقیت یکی از دوره‌های فرادرس را بگذرانم و گواهینامه بگیرم.",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "خوشحالم که دوره‌ای در فرادرس را با موفقیت به پایان رسانده و گواهینامه دریافت کرده‌ام.",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "با افتخار اعلام می‌کنم که یکی از دوره‌های فرادرس را گذرانده‌ام و گواهینامه گرفته‌ام.",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "اینک با افتخار دوره‌ای در فرادرس را به اتمام رسانده و گواهینامه خود را اخذ نموده‌ام.",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "یکی از دوره‌های فرادرس را با موفقیت گذرانده و گواهینامه خود را دریافت کردم.",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "به تازگی موفق به اتمام یکی از دوره‌های فرادرس شدم و گواهینامه‌ام را دریافت نمودم.",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence: "با اتمام دوره‌ای در فرادرس، اکنون گواهینامه‌ام را در دست دارم.",
    tone: "formal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
];
